import { css } from '@emotion/css';
import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import { ConfirmDelete } from './ConfirmDelete';
import { MenuList } from './MenuList';

export const MyDesignDetailMenu: React.FC = () => {
  const routeMatch = useRouteMatch<{ page: string }>();
  return (
    <div
      className={css`
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: #f5f1e3;
        transition: opacity 0.15s;
      `}
    >
      {(() => {
        switch (routeMatch?.params?.page) {
          case '1':
            return <MenuList />;
          case '2':
            return <ConfirmDelete />;
          default:
            return <></>;
        }
      })()}
    </div>
  );
};
